import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from 'material-ui-beta/styles';
import { CircularProgress } from 'material-ui-beta/Progress';

import DataStore from '../../api/DataStore';
import DataManager from '../../api/DataManager.js';
import Tracker from '../common/Tracker';
import Nav from '../admin-nav/Nav';
import AdminAppBar from '../admin-appbar/AdminAppBar';
import NavItems from '../admin-nav/NavItems';
import AdminLocationManager from '../admin-location-manager/AdminLocationManager';
import AdminResources from '../admin-resources/AdminResources';
import AdminMemberResources from '../admin-member-resources/AdminMemberResources';
import AdminSubscriptions from '../admin-subscriptions/AdminSubscriptions';
import AdminPurchaseHistory from '../admin-purchase-history'
import ShoppingCart from '../admin-shopping-cart/ShoppingCart';
import AdminQueryReport from '../admin-query-report';
import AdminLocationReport from '../admin-location-report';

import './AdminPanel.css';

const dataManager = new DataManager();
const dataStore = new DataStore();
const CATEGORY = "location manager";

const theme = createMuiTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#1c5c7f',
            // dark: will be calculated from palette.primary.main,
            contrastText: "#ffffff"
        },
        secondary: {
            // light: '#ffd400',
            main: '#53c9e8',
            // dark: will be calculated from palette.secondary.main,
            contrastText: "#ffffff"
        },
        // error: will us the default color
    },
    overrides: {
        MuiButton: {
            // Name of the styleSheet
            root: {
                color: 'white'
            },
        },
    }
});

class AdminPanel extends Component {

    constructor(props) {
        super(props);

        console.log("shoppingCart", dataStore.getShoppingCart());

        this.state = {
            user: null,
            loading: true,
            shoppingCart: dataStore.getShoppingCart(),
            showCart: false
        }

        console.log("Cart", this.state.shoppingCart);
    }

    componentDidMount() {
        this.fetchUser();
    }

    onNavItemClick = (item) => {
        document.location.href = "/#admin/" + NavItems.sanitize(item);
        this.setState({
            selectedNavItem: item
        });
    }

    getSelectedItemTitle = () => {
        if (this.props.location[1]) {
            return NavItems[this.props.location[1]];
        }
        return NavItems.location_manager;
    }

    getMainContent() {
        switch (this.getSelectedItemTitle()) {
            case NavItems.admin_resources:
                return <AdminResources user={this.state.user} />;
            case NavItems.admin_query_report:
                return <AdminQueryReport />;
            case NavItems.admin_location_report:
                return <AdminLocationReport />;
            case NavItems.member_resources:
                return <AdminMemberResources user={this.state.user} cart={this.state.shoppingCart} onAddItemToCart={this.onAddItemToCart} />;
            case NavItems.subscriptions:
                return <AdminSubscriptions user={this.state.user} />;
            case NavItems.purchase_history:
                return <AdminPurchaseHistory user={this.state.user} />;
            case NavItems.location_manager:
            default:
                return <AdminLocationManager location={this.props.location} user={this.state.user} />;
        }
    }

    fetchUser() {
        dataManager.fetchUser(user => {
            console.log("user", user);
            this.setState({
                loading: false,
                user: user
            });
        }, error => {
            Tracker.trackEvent(CATEGORY, "user auth failed", "", "");
            document.location.href = "/#";
        });
    }

    onAddItemToCart = (item) => {
        item.autoRenew = false;
        let cart = [].concat(this.state.shoppingCart);

        if (!this.cartHasItem(cart, item)) {
            cart.push(item);
        }

        this.setState({
            shoppingCart: cart,
            showCart: true
        });
        dataStore.saveShoppingCart(cart);
    }

    cartHasItem(cart, item) {
        let hasItem = false;
        cart.forEach(cartItem => {
            if (cartItem.resource.id === item.resource.id && cartItem.selectedOption === item.selectedOption) {
                hasItem = true;
            }
        });
        return hasItem;
    }

    onToggleCart = () => {
        this.setState({
            showCart: !this.state.showCart
        });
    }

    onRemoveItemFromCart = (index) => {
        let cart = [].concat(this.state.shoppingCart);
        cart.splice(index, 1);
        this.setState({
            shoppingCart: cart,
            showCart: cart.length > 0
        });
        dataStore.saveShoppingCart(cart);
    }

    clearCart = () => {
        let cart = [];
        this.setState({
            shoppingCart: cart,
            showCart: false
        });
        dataStore.saveShoppingCart(cart);
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <div className="admin-panel-container flex">
                    <Nav
                        onNavItemClick={this.onNavItemClick}
                        selectedItem={this.getSelectedItemTitle()}
                        user={this.state.user} />
                    <div className="flex1 flex column">
                        <AdminAppBar title={this.getSelectedItemTitle()} />
                        <div className="admin-panel-content-container flex1 flex column">
                            {this.state.loading ?
                                <div className="flex centerBoth marginTop20">
                                    <CircularProgress size={50} />
                                </div>
                                :
                                this.getMainContent()
                            }
                        </div>
                    </div>
                    <ShoppingCart
                        open={this.state.showCart}
                        cart={this.state.shoppingCart}
                        onToggleCart={this.onToggleCart}
                        onRemoveClick={this.onRemoveItemFromCart}
                        user={this.state.user}
                        clearCart={this.clearCart} />
                </div>
            </MuiThemeProvider>
        )
    }

}

export default AdminPanel;


// WEBPACK FOOTER //
// ./src/components/admin/AdminPanel.js